import type * as CSSTransition from "react-transition-group/CSSTransition";

// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { IButtonStyles } from "@fluentui/react";
import type { IStyle } from "@fluentui/react/lib/Styling";
import {
  getHighContrastNoAdjustStyle,
  HighContrastSelector,
} from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

const opacityDuration = 50;
const widthDuration = 300;
export const labelExitTransitionDuration = opacityDuration;
export const labelEnterTransitionDuration = widthDuration + opacityDuration;
export const labelTransitionClassNames: CSSTransition.CSSTransitionClassNames =
  {
    exit: "ribbonButtonLabel-exit",
    exitActive: "ribbonButtonLabel-exit-active",
    enter: "ribbonButtonLabel-enter",
    enterActive: "ribbonButtonLabel-enter-active",
    enterDone: "ribbonButtonLabel-enter-done",
  };

export const ribbonButtonHighContrastStyles: IButtonStyles = {
  root: {
    selectors: {
      [HighContrastSelector]: {
        borderColor: "transparent",
      },
    },
  },
};

export const getRibbonButtonLabelTransitionStyles = memoizeFunction(
  (
    textContainerEnterInitialWidth: number | undefined,
    textContainerEnterFinalWidth: number | undefined,
    hideLabel: boolean | undefined
  ): IButtonStyles => {
    let labelEnterStyles: { [key: string]: IStyle };
    if (hideLabel) {
      // There's no ms-Button-textContainer, animate margin of ms-Button-icon instead
      labelEnterStyles = {
        [`.${labelTransitionClassNames.enter}:not(.${labelTransitionClassNames.enterActive}) & .ms-Button-icon`]:
          {
            marginRight:
              textContainerEnterInitialWidth != null
                ? `${textContainerEnterInitialWidth}px`
                : undefined,
          },
        [`.${labelTransitionClassNames.enterActive} & .ms-Button-icon`]: {
          transition: `margin-right ${widthDuration}ms  cubic-bezier(0.1, 0.9, 0.2, 1)`,
          marginRight:
            textContainerEnterFinalWidth != null
              ? `${textContainerEnterFinalWidth}px`
              : undefined,
        },
      };
    } else {
      // Transition the ms-Button-textContainer max-width
      labelEnterStyles = {
        [`.${labelTransitionClassNames.enter}:not(.${labelTransitionClassNames.enterActive}) & .ms-Button-textContainer`]:
          {
            maxWidth:
              textContainerEnterInitialWidth != null
                ? `${textContainerEnterInitialWidth}px`
                : undefined,
            opacity: 0,
          },
        [`.${labelTransitionClassNames.enterActive} & .ms-Button-textContainer`]:
          {
            opacity: 1,
            maxWidth:
              textContainerEnterFinalWidth != null
                ? `${textContainerEnterFinalWidth}px`
                : undefined,
            transition: `max-width ${widthDuration}ms cubic-bezier(0.1, 0.9, 0.2, 1), opacity ${opacityDuration}ms linear ${widthDuration}ms`,
          },
      };
    }

    const styles: IButtonStyles = {
      root: {
        selectors: {
          [`.${labelTransitionClassNames.exit} & .ms-Button-textContainer`]: {
            opacity: 1,
          },
          [`.${labelTransitionClassNames.exit}.${labelTransitionClassNames.exitActive} & .ms-Button-textContainer`]:
            {
              opacity: 0,
              transition: `opacity ${opacityDuration}ms linear`,
            },
          [HighContrastSelector]: {
            border: "1px solid transparent",
            ...getHighContrastNoAdjustStyle(),
          },
          ...labelEnterStyles,
        },
        display: "inline-block",
      },
      splitButtonMenuButton: {
        selectors: {
          [HighContrastSelector]: {
            border: "1px solid transparent",
          },
        },
      },
      textContainer: "ms-Button-textContainer",
      icon: "ms-Button-icon",
    };

    return styles;
  }
);
